module.exports = __webpack_public_path__ + "static/media/cp2.14980f21.png";